import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { backend_url } from '../../App';

const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/faq`);
      setFaqs(response.data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    }
  };

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-[90%] mx-auto px-4 py-12">
      {/* Title */}
      <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-center mb-6" 
           style={{ fontFamily: "'Times New Roman', Serif" }}>
        Frequently Asked Questions
      </h2>
      <div className="flex justify-center mb-10">
        <hr className="w-3/4 md:w-1/2 h-1 bg-black rounded-xl" />
      </div>

      {/* FAQ Section */}
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={faq._id} className="border-b border-gray-300">
            {/* Question */}
            <button
              className="w-full flex justify-between items-center py-4 text-left transition-colors hover:text-purple-500"
              onClick={() => toggleFaq(index)}
            >
              <div className="flex items-center gap-3">
                <img crossOrigin="anonymous" 
                  src={`${faq.icon_image}`}
                  alt="icon"
                  className="w-8 h-8 object-cover"
                />
                <span className="text-base md:text-lg font-medium">{faq.question}</span>
              </div>
              <span className={`text-xl transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : 'rotate-0'}`}>
                {openIndex === index ? '−' : '+'}
              </span>
            </button>

            {/* Answer */}
            <div
              className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <p className="py-4 text-gray-700 text-sm md:text-base leading-relaxed">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );  
};

export default Faq;
